import React from 'react';
import PropTypes from 'prop-types';
import "./Pages.scss";

const PageNumber = ({ currentPage, pageNumber, onSetPage }) => {
    return currentPage !== pageNumber ? (
        <div className='page-num' onClick={() => onSetPage(pageNumber)}>
            <a>{pageNumber + 1}</a>
        </div>
    ) : (
        <div className='page-num selected'>
            {pageNumber + 1}
        </div>
    )
}

PageNumber.propTypes = {
    currentPage: PropTypes.number.isRequired,
    pageNumber: PropTypes.number.isRequired,
    onSetPage: PropTypes.func.isRequired
}

export default PageNumber;